export default __webpack_public_path__ + "static/media/sortUp.5d13a5d6.svg";